var $e035bb252e07dc4e$exports = {};
$e035bb252e07dc4e$exports = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `Izbirnik barv`,
    "colorSwatch": `barvna paleta`,
    "transparent": `prozorno`,
    "twoDimensionalSlider": `2D drsnik`
};


export {$e035bb252e07dc4e$exports as default};
//# sourceMappingURL=sl-SI.mjs.map
